import React from 'react';
import { 
  Database, 
  Zap, 
  Globe, 
  BarChart3, 
  Workflow, 
  Code,
  ArrowRight,
  CheckCircle
} from 'lucide-react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: <Database className="service-icon" />,
      title: "Data & Workflow Automation",
      description: "Transform your data management with intelligent automation solutions across multiple platforms.",
      features: [
        "Automated data collection and processing",
        "Custom workflows and approval processes",
        "Real-time reporting and dashboards",
        "Multi-platform integrations"
      ],
      gradient: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)"
    },
    {
      icon: <Zap className="service-icon" />,
      title: "Business Process Automation",
      description: "Streamline your operations with custom automation solutions tailored to your needs.",
      features: [
        "Process analysis and optimization",
        "Custom automation development",
        "API integrations and connections",
        "Workflow management systems"
      ],
      gradient: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)"
    },
    {
      icon: <Globe className="service-icon" />,
      title: "Custom Website Development",
      description: "Build powerful, responsive websites that drive results for your business.",
      features: [
        "Modern, responsive web design",
        "Custom web application development",
        "E-commerce solutions",
        "Performance optimization"
      ],
      gradient: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)"
    }
  ];

  const additionalServices = [
    {
      icon: <BarChart3 size={24} />,
      title: "Data Analytics & Reporting",
      description: "Turn your data into actionable insights with custom analytics solutions."
    },
    {
      icon: <Workflow size={24} />,
      title: "System Integration",
      description: "Connect your tools and platforms for seamless data flow and automation."
    },
    {
      icon: <Code size={24} />,
      title: "Custom Software Solutions",
      description: "Bespoke software development to solve your unique business challenges."
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <div className="services-header">
          <h2>Our Expertise</h2>
          <p>We specialize in multi-platform automation and development solutions that transform how you work</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-card-header" style={{ background: service.gradient }}>
                {service.icon}
                <h3>{service.title}</h3>
              </div>
              <div className="service-card-body">
                <p>{service.description}</p>
                <ul className="service-features">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex}>
                      <CheckCircle size={16} className="check-icon" />
                      {feature}
                    </li>
                  ))}
                </ul>
                <a 
                  href="https://app.smartsheet.com/b/form/819a65d4d35b4bf589f8f0cdd783842c" 
                  className="service-cta"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Learn More <ArrowRight size={16} />
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="additional-services">
          <h3>Additional Services</h3>
          <div className="additional-services-grid">
            {additionalServices.map((service, index) => (
              <div key={index} className="additional-service-card">
                <div className="additional-service-icon">
                  {service.icon}
                </div>
                <div className="additional-service-content">
                  <h4>{service.title}</h4>
                  <p>{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="services-cta">
          <div className="cta-content">
            <h3>Ready to Transform Your Business?</h3>
            <p>Let's discuss how our automation and development solutions can help you achieve your goals.</p>
            <a 
              href="https://app.smartsheet.com/b/form/819a65d4d35b4bf589f8f0cdd783842c" 
              className="btn btn-primary btn-large"
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Your Free Consultation <ArrowRight size={20} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
